import * as apiHelpers from '../API';
import * as firebaseHelpers from '../Firebase';
const MIDDLE_loginAttempts = 3;
const MAX_loginAttempts = 6;

export async function createAccount(formData, accountType) {
  let token;

  if (accountType === 1) {
    token = await apiHelpers.createAccount(formData);
  } else {
    token = await apiHelpers.createMerchantAccount(formData);
  }
  await firebaseHelpers.setPersistence(formData.rememberMe);
  const user = await firebaseHelpers.signInWithToken(token);
  await apiHelpers.loginSuccess();
  return user;
}

export async function login({
  email, password, rememberMe,
}) {
  const loginAttempts = await apiHelpers.login(email);
  await firebaseHelpers.setPersistence(rememberMe);

  try {
    const { user } = await firebaseHelpers.signInWithEmailAndPassword(
      email,
      password
    );
    await apiHelpers.loginSuccess();
    return user;
  } catch (e) {
    if (loginAttempts >= MIDDLE_loginAttempts) {
      const remainingAttempts = MAX_loginAttempts - loginAttempts;
      const error = new Error(
        `You will be temporarily unable to login for 30 minutes after ${remainingAttempts} more unsuccessful login attempt${
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
          remainingAttempts === 1 ? '' : 's'
        }.`
      );
      error.code = 'auth/rate-limit-warning';
      throw error;
    }
    throw e;
  }
}

export async function resetPassword(email) {
  try {
    await firebaseHelpers.resetPassword(email);
    return true;
  } catch (e) {
    if (e.code === 'auth/user-not-found') {
      return true;
    }
    alert(e.message || e);
  }
}

export function getAccountType() {
  return apiHelpers.getAccountType();
}

export function removeUnusableCards(cards, processorTypes) {
  return cards.filter(({ paymentType, processorType }) => processorTypes[paymentType] === processorType);
}